// @erp/ui/footer — daisyUI `footer footer-center` (components/footer syntax).
// Only renders fields the caller actually supplies — no fabricated version or
// build info (ADR-003 §4 honesty ledger applies to chrome, not just data screens).
import { BrandMark, BRAND_NAME } from "../brand/index.js";

export function Footer(props: { appName?: string; version?: string; brandColor?: string }) {
  const full = () => props.appName ?? BRAND_NAME;
  const cut = () => full().indexOf(" · ");
  const productName = () => (cut() === -1 ? full() : full().slice(0, cut()));
  const rest = () => (cut() === -1 ? "" : full().slice(cut()));
  return (
    // A RIBBON, not a band: the console is a working surface and the colophon
    // must cost as little of it as possible — one 28px line, 10px ink, pinned
    // by the shell to the bottom of the frame rather than floating after the
    // page content. `brandColor` keeps the mark in step with the portal's own
    // (a green mark under a pink chrome was the reported mismatch).
    <footer class="flex h-7 shrink-0 items-center justify-center gap-1.5 border-t border-base-300 bg-base-100 px-4 text-xs text-base-subtle">
      <BrandMark size={11} class="shrink-0" color={props.brandColor} />
      <span class="truncate">
        {/* The PRODUCT name carries the weight; whatever follows the first
            separator is the surface ("· Circulation desk") and stays plain, so
            the colophon reads as one product with a room name after it. */}
        <span class="font-medium text-base-subtle">{productName()}</span>
        {rest()}
        {props.version ? ` · v${props.version}` : ""} · © {new Date().getFullYear()}
      </span>
    </footer>
  );
}
